import {styled, keyframes} from "@core-ui/react-stitch";
import React from "react";

const dotAnimation = keyframes`
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`;

const LoadingDotsAnimation = styled.div`
  width: 100%;
  text-align: center;

  & > div {
    width: 1rem;
    height: 1rem;
    background-color: currentColor;
    margin: 0.1rem;

    border-radius: 50%;
    display: inline-block;
    animation: ${dotAnimation} 1.4s infinite ease-in-out both;
  }

  & :nth-of-type(1) {
    animation-delay: -0.32s;
  }

  & :nth-of-type(2) {
    animation-delay: -0.16s;
  }
`;

const LoadingAnimation = (): JSX.Element => {
  return (
    <LoadingDotsAnimation
      aria-busy="true"
      aria-label="loading"
      aria-live="polite"
      role="alert"
    >
      <div />
      <div />
      <div />
    </LoadingDotsAnimation>
  );
};

export default LoadingAnimation;
